import defaultReplication from '@/rxdb/defaultReplication';
import { preInsert, preRemove, preSave } from '@/rxdb/defaultHooks';

export const supportsExports = {
    schema: {
        title: 'supportsExports schema',
        version: 0,
        description: 'describes a supportsExports',
        primaryKey: 'id',
        type: 'object',
        properties: {
            id: {
                type: 'string',
                final: true,
                maxLength: 40,
            },
            projectId: { type: 'string' },
            generationEndDate: { type: ['string', 'null'] },
            generationStartDate: { type: ['string', 'null'] },
            generationSucceeded: { type: ['boolean', 'null'] },
            url: { type: ['string', 'null'] },
            fileName: { type: 'string' },
            sortKey: { type: ['string', 'null'] },
            sortAsc: { type: ['boolean', 'null'] },
            showDone: { type: ['boolean', 'null'] },
            showFar: { type: ['boolean', 'null'] },
            showComing: { type: ['boolean', 'null'] },
            filter: { type: 'array', items: { type: 'object' } },
            createdBy: { type: ['string', 'null'] },
            updatedAt: { type: ['string', 'null'] },
            deletedAt: { type: ['string', 'null'] },
            deletedBy: { type: ['string', 'null'] },
            createdAt: { type: ['string', 'null'] },
            updatedBy: { type: ['string', 'null'] },
            rootVersion: { type: ['string', 'null'] },
        },
    },
    options: {
        onCollectionCreated(projectId, rxCollection) {
            rxCollection.replicationState = defaultReplication(rxCollection, projectId);
            rxCollection.preRemove(preRemove, false);
            rxCollection.preInsert(preInsert, false);
            rxCollection.preSave(preSave, false);
        },
    },
    migrationStrategies: {},
};
